module.exports = __webpack_public_path__ + "static/media/group-avatar.30311ea2.svg";